import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CoreApi } from '@inter-ikea-storageone/range';
import { RootState } from 'ducks';
import { Dispatch } from 'redux';
import { selectGroup } from './products';

export interface DesignIdState {
  designId: string | null;
  vpcImageUrl: string | null;
}

const initialState: DesignIdState = {
  designId: null,
  vpcImageUrl: null
};

export const attachDesignIdSubscribers = (dispatch: Dispatch, coreApi: CoreApi) => {
  coreApi.subscribe('saveDesignId', designId => {
    dispatch(saveDesignId(designId));
  });
  coreApi.subscribe('loadDesignId', () => {
    dispatch(selectGroup(''));
  });
};

// Slice that creates a reducer and actions

const designIdSlice = createSlice({
  name: 'designId',
  initialState,
  reducers: {
    resetDesignId(state) {
      Object.assign(state, initialState);
    },
    saveDesignId(state, action: PayloadAction<string>) {
      state.designId = action.payload;
    },
    saveVpcImageUrl(state, action: PayloadAction<string>) {
      state.vpcImageUrl = action.payload;
    }
  }
});

// Selectors

export const getDesignId = (state: RootState) => state.designId.designId;
export const getVpcImageUrl = (state: RootState) => state.designId.vpcImageUrl;

// Exports

export const { resetDesignId, saveDesignId, saveVpcImageUrl } = designIdSlice.actions;

export default designIdSlice.reducer;
